import { useState, useEffect } from "react";
import axios from "axios";
import ShareModal from "./shareModel";

const BASE_URL = process.env.REACT_APP_API_BASE_URL

const CourseHeader = ({ course }) => {
  const [inWishlist, setInWishlist] = useState(false);
  const [loadingWishlist, setLoadingWishlist] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const checkWishlist = async () => {
      try {
        const token = localStorage.getItem("access");
        const response = await axios.get(`${BASE_URL}/users/wishlist/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const wishlistCourses = response.data.map((item) => item.course.id);
        setInWishlist(wishlistCourses.includes(course.id));
      } catch (err) {
        //console.error("Failed to check wishlist:", err);
      }
    };
    checkWishlist();
  }, [course.id]);

  const handleWishlistToggle = async () => {
    setLoadingWishlist(true);
    try {
      const token = localStorage.getItem("access");
      if (inWishlist) {
        await axios.delete(`${BASE_URL}/users/wishlist/remove/${course.id}/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setInWishlist(false);
      } else {
        await axios.post(
          `${BASE_URL}/users/wishlist/add/${course.id}/`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setInWishlist(true);
      }
    } catch (err) {
      //("Wishlist action failed:", err);
    } finally {
      setLoadingWishlist(false);
    }
  };

  const openShareModal = () => setIsModalOpen(true); // Function to open modal
  const closeShareModal = () => setIsModalOpen(false);

  return (
    <div className="course-header">
      <div className="course-header-content">
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h1 className="course-title">{course.title}</h1>
            <span className="course-category">Nurse Assist International</span> {/* Adjust if category is added */}
          </div>
          <div className="course-actions">
            <button
              className="btn btn-outline-warning me-2"
              onClick={handleWishlistToggle}
              disabled={loadingWishlist}
            >
              <i className={`fas fa-heart ${inWishlist ? "text-danger" : ""}`}></i>{" "}
              {inWishlist ? "Remove from Wishlist" : "Wishlist"}
            </button>
            {/*<button className="btn btn-outline-secondary" onClick={openShareModal}>
              <i className="fas fa-share"></i> Share
            </button>*/}
          </div>
        </div>

        <div className="course-image-container">
          <img
            src={course.image || "/placeholder.svg"}
            alt={course.title}
            className="course-detail-image"
          />
        </div>
      </div>
       {/* Show the ShareModal when modal is open */}
       {isModalOpen && <ShareModal link={`${BASE_URL}/courses/${course.id}`} onClose={closeShareModal} />}
    </div>
  );
};

export default CourseHeader;